import '@babel/polyfill';
"use strict";

function stickyHeaderScroll() {
    if(!document.querySelector('.header-top')) return;
        let scrollPosition = 0;
        const headerTop = document.querySelector('.header-top');
        function headerSticky() {

            function debounce(func, wait = 10, immediate = true) {
                let timeout;
                return function() {
                  let context = this, args = arguments;
                  let later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                  };
                  let callNow = immediate && !timeout;
                  clearTimeout(timeout);
                  timeout = setTimeout(later, wait);
                  if (callNow) func.apply(context, args);
                };
              };


            const checkPosition = () => {
                const windowY = window.scrollY;
                if(windowY < scrollPosition) {
                    headerTop.classList.remove('header-hidden');
                    headerTop.classList.add('header-visible');
                }else {
                    headerTop.classList.remove('header-visible');
                    headerTop.classList.add('header-hidden');
                }
                scrollPosition = windowY;
            }
            window.addEventListener('scroll', debounce(checkPosition));
        }

    headerSticky();
}

export default stickyHeaderScroll;